import '~/js/modules/section-hero';
import 'magnific-popup';

const $main = $('body');
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isSafari) {
  $main.addClass('mfp-min-width');
}

$('.popup-player-local').magnificPopup({
  type: 'iframe',
  mainClass: 'mfp-autism-friendly',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: true,
  items: {
    src: '<div class="mfp-local-video">' +
      '<div class="mfp-close">&nbsp;</div>' +
      '<video controls autoplay playsinline><source src="https://cdn.sandals.com/beaches/v11/site-elements/specials/videos/IBCCES-Interview-Videos-Q5.mp4" type="video/mp4"></video>' +
      '</div>',
    type: 'inline'
  }
});
